export const GET_FEEDBACK_QUESTIONS = 'GET_FEEDBACK_QUESTIONS';
export const GET_FEEDBACK_ANSWERS = 'GET_FEEDBACK_ANSWERS';
export const GET_FEEDBACK_WAITERS = 'GET_FEEDBACK_WAITERS';
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_ERROR = 'SEND_FEEDBACK_ERROR';
